import type { IHttpPromise } from 'angular';

type HttpPostOnly = {
  post: (url: string) => IHttpPromise<unknown>;
};

/**
 * ログイン時に開始した、現在パスワードの検証免除期限をクリアする。
 * CSRF トークンを付与するインターセプタを通すため、AngularJS の $http で送信する
 */
export const clearCurrentPasswordWaiver = ($http: HttpPostOnly): IHttpPromise<unknown> =>
  $http.post('/api/v4/admin/auth/password-change-required/clear');
